import React from "react";
import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import CatalogueSubGroupCustomTypes, {
  Props,
} from "./CatalogueSubGroupCustomTypes";

export default (props: Props) => (
  <Page>
    <CatalogueSubGroupCustomTypes {...props} />
  </Page>
);
